import { render, staticRenderFns } from "./LoadButton.vue?vue&type=template&id=a839301c&"
import script from "./LoadButton.vue?vue&type=script&lang=js&"
export * from "./LoadButton.vue?vue&type=script&lang=js&"
import style0 from "./LoadButton.vue?vue&type=style&index=0&id=a839301c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports